/**************************************************
 * Nombre:       Home_Capacitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Capacitaciones from "../../Tarjetas/Tarjeta_Capacitaciones";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Capacitaciones = () => {
    const {sCell} = useResponsive()
    const [capacitaciones, setCapacitaciones] = useState([]);

    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'capacitaciones', wheres: w}).then((dox) =>{
            setCapacitaciones(dox.data)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                overflowX: 'hidden',

            }}
        >
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{color: '#262626', fontSize: sCell ? 32 : 40, fontWeight: 700, lineHeight: 1}}>
                                        Ultimas Capacitaciones
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 5}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 0}}>
                                    <Typography sx={{color: '#545454', fontSize: 16, fontWeight: 400}}>
                                        Lo más reciente en formación y crecimiento del Team Tufiño
                                    </Typography>
                                </Grid>


                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: 8}}>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={4}
                            >

                                {capacitaciones.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Capacitaciones item={it}/>
                                    </Grid>
                                ))}

                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Capacitaciones

const items = [1, 2]